import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
const statusesApi = buildService('/claim_groups/{id}/technical_narrative_upload_status', {
  only: ['all', 'base']
}, {
  only: ['postFormData']
});
const technicalNarrativesApi = buildService('/claim_groups/{id}/technical_narrative_imports', {
  only: ['all', 'base']
}, {
  only: ['postFormData']
});
const importNarrativeService = {
  create(claimGroupId, formData) {
    return fetch(`/api/claim_groups/${claimGroupId}/technical_narrative_imports/`, {
      ...request.post,
      headers: {
        'Accept': 'application/json, text/plain, */*'
      },
      body: formData
    });
  }
};
const useFetchTechnicalNarrativeImportStatusWithInterval = _ref => {
  let {
    claimGroupId,
    setLoading
  } = _ref;
  const {
    interval,
    setInterval,
    stateVar: importStatus,
    setStateVar: setImportStatus
  } = serviceMethods.useFetchWithInterval({
    api: statusesApi,
    callback: useCallback(async () => await statusesApi.all(claimGroupId), [claimGroupId]),
    setLoading
  });
  return {
    importStatus,
    setImportStatus,
    interval,
    setInterval
  };
};
const useUploadTechnicalNarrative = _ref2 => {
  let {
    claimGroupId,
    setLoading,
    handleToaster,
    onSuccess
  } = _ref2;
  const {
    t
  } = useTranslation();
  //accepts an object with the formDataJson field and any other fields.
  const postFormData = serviceMethods.usePostFormDataFileFromEvent({
    setLoading,
    onSuccess,
    handleToaster,
    callback: useCallback(async _ref3 => {
      let {
        formData
      } = _ref3;
      const result = await technicalNarrativesApi.postFormData(claimGroupId, formData);
      handleToaster('success', t('upload_is_in_progress'));
      return result;
    }, [claimGroupId, handleToaster, t])
  });
  return postFormData;
};
const claimGroupTechnicalNarrativeService = {
  ...importNarrativeService,
  useFetchTechnicalNarrativeImportStatusWithInterval,
  useUploadTechnicalNarrative
};
export default claimGroupTechnicalNarrativeService;